import { useGameStore } from '@src/data/useGameStore';
import { Text } from 'ui_2';

const roundText = ['First', 'Second', 'Third'];

export const NewRound = () => {
  const [round, rounds] = useGameStore((state) => [state.round, state.rounds]);

  return (
    <div
      key={round}
      className='pointer-events-none absolute bottom-20 left-1/2 z-20 flex h-[163px] w-[292px] -translate-x-1/2 transform animate-appear-and-fade flex-col items-center justify-center rounded-[20px] bg-black'
    >
      <Text family='space' font='lg' className='text-aqua'>
        {round + 1} of {rounds}
      </Text>
      <Text family='space' font='lg' className='text-aqua'>
        {roundText[round ?? 0]} Round
      </Text>
    </div>
  );
};
